import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getDairyFootprintByYear, getDairyFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_DAIRY } from "consts";

export const useGetFootprintingDairyFootprint = (farmId?: string, year?: number, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const enableQuery = isAdmin
    ? (enabled && !!farmId && !!year) ?? false
    : (enabled && !!farmId && !!year && !!user && carbonProgram?.platformFeatures?.footprinting?.enabled && !!token) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY, farmId, year, isAdmin],
      queryFn: async () => (isAdmin ? getDairyFootprintByYearAdmin(farmId ?? "", year ?? 0) : getDairyFootprintByYear(farmId ?? "", year ?? 0)),
      enabled: enableQuery,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
